import { power_supply } from './power_supply';

import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';

export class ncv8187amt110tag extends power_supply {
	constructor(opn) {
		super(opn, 'ncv8187');
		this.PACKAGE_IMAGE = require(`../../images/WDFN6_CASE_511BR.png`);
		this.SCHEMATIC_DC = require(`../../images/${this.opn}_SCH_DC.svg`);
		this.SCHEMATIC_TRAN = require(`../../images/${this.opn}_SCH_TRAN.svg`);
		this.modelLink = '';
	}

	gainDefinition() {
		const DC_CHART_COLUMN_MAPPING = {
			V_PG: 7
		};
		const TRANSIENT_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			R_LOAD: 2,
			V_IN: 3,
			V_PG: 4,
			V_EN: 5,
			V_OUT: 6,
			I_OUT: 7,
			I_GND: 8
		};
		const customizations = {
			simulations: [
				{
					showInputParams: false,
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'V_INmin',
							minBoundary: 0.1,
							maxBoundary: 2.4,
							defaultValue: 0.5
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 0.2,
							maxBoundary: 2.5,
							defaultValue: 2
						},
						{
							heading: 'V<sub>IN<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INstep',
							minBoundary: 0.01,
							maxBoundary: 2.5,
							defaultValue: 0.05
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 1.15,
							maxBoundary: 100,
							defaultValue: 1.2
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 1.16,
							maxBoundary: 100,
							defaultValue: 6
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 25,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -55,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_DC
					},
					charts: [
						{},
						{},
						{},
						{},
						{},
						{
							/**
							 * --------------------------------------------------- V_PG vs V_IN ---------------------------------------------------
							 */
							id: 'VpgVsVin',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]PG[/] = f (V[baseline-shift: sub; font-size: 11px;]IN[/], R[baseline-shift: sub; font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_IN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PG[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: DC_CHART_COLUMN_MAPPING.V_PG
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				},
				{
					showInputParams: false,
					inputParameters: [
						{
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmin',
							minBoundary: 0.1,
							maxBoundary: 2.4,
							defaultValue: 0.5
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 0.2,
							maxBoundary: 2.5,
							defaultValue: 2
						},
						{
							heading: 't<sub>rise<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtr',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>fall<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtf',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>ON<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtON',
							minBoundary: 0.01,
							maxBoundary: 50,
							defaultValue: 3
						},
						{
							heading: 'V<sub>EN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_ENmin',
							minBoundary: 0,
							maxBoundary: 5.4,
							defaultValue: 0
						},
						{
							heading: 'V<sub>EN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_ENmax',
							minBoundary: 0.1,
							maxBoundary: 5.5,
							defaultValue: 5
						},
						{
							heading: 't<sub>EN<sub>delay</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtDelay',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>EN<sub>rise</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtr',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>EN<sub>ON</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtON',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>EN<sub>fall</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtf',
							minBoundary: 0.01,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 't<sub>step<sub>max</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'Tstep',
							minBoundary: 0.001,
							maxBoundary: 0.1,
							defaultValue: 0.1
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 1.15,
							maxBoundary: 100,
							defaultValue: 1.2
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 1.16,
							maxBoundary: 100,
							defaultValue: 6
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 6,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 'C<sub>IN</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cin',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 1
						},
						{
							heading: 'ESR<sub>C<sub>IN</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCin',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>OUT</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cout',
							minBoundary: 4.7,
							maxBoundary: 1000,
							defaultValue: 10
						},
						{
							heading: 'ESR<sub>C<sub>OUT</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCout',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -55,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_TRAN
					},
					charts: [
						{
							id: 'ComposedChart',
							mainHeading: 'Timing Diagram',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'Voltage',
									unit: UNITS_SIGN.VOLT
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'VinVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]IN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VenVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]EN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VpgVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]PG[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VoutVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								}
							],
							series: {
								heading: 'Voltage dependence',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VinVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VenVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]EN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]EN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_EN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VpgVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]PG[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PG[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_PG
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VoutVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IoutVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IgndVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]GND[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				}
			]
		};

		return super.gainDefinition(customizations);
	}
}
